<template>
  <el-radio-group v-model="invalue">
    <el-radio-button v-for="opt in options" :key="opt.value" :label="opt.value">
      {{ opt.label }}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
export default {
  props: { value: { type: String, default: '' } },
  data() {
    return {
      invalue: '',
      options: [
        { label: this.$l('radio_label_high') || 'High', value: 'High' },
        { label: this.$l('radio_label_medium') || 'Medium', value: 'Medium' },
        { label: this.$l('radio_label_low') || 'Low', value: 'Low' },
      ],
    }
  },
  watch: {
    value() {
      this.invalue = this.value
    },
    invalue(val) {
      this.$emit('update:value', val)
      this.$emit('input', val)
    },
  },
  created() {
    this.invalue = this.value
  },
}
</script>

<style scoped></style>
